export const sorts = {
  default: [],
  options: [
    { name: 'Status', key: 'status', options: [{ key: '-status', value: 'Most' }, { key: 'status', value: 'Least' }] },
    { name: 'End date', key: 'ends_at', options: [{ key: '-ends_at', value: 'Most' }, { key: 'ends_at', value: 'Least' }] },
    { name: 'Bonus gift', key: 'earned_amount', options: [{ key: '-earned_amount', value: 'Most' }, { key: 'earned_amount', value: 'Least' }] }
  ]
};
